import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  height: 24px;\n  width: 24px;\n  position: absolute;\n  padding: 0;\n  top: -10px;\n  right: 0;\n  border: 0;\n  background: transparent;\n  cursor: pointer;\n  &:focus,\n  &:hover {\n    border-color: transparent;\n    outline: none;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  & input {\n    padding: 0 50px 0 0px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React, { useState } from 'react';
import { AcornsIcon } from '@acorns/icons';
import styled from '../../utils/styling/styled-components';
import { PRIVATE_INPUT_TOGGLE, TEXT_INPUT } from '../../utils/testing/TestIDs';
import { BaseTextInputV3 } from './BaseTextInputV3';
import { HelperText } from './HelperText';
var StyledTextInput = styled(BaseTextInputV3)(_templateObject());
var StyledShowButton = styled.button(_templateObject2());

var ShowButton = function ShowButton(_ref) {
  var children = _ref.children,
      onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement(StyledShowButton, {
    type: "button",
    "data-testid": PRIVATE_INPUT_TOGGLE,
    onClick: onClick
  }, children);
};

var PrivateInputV3 = function PrivateInputV3(_ref2) {
  var customToggle = _ref2.customToggle,
      error = _ref2.error,
      errorText = _ref2.errorText,
      _ref2$isRevealable = _ref2.isRevealable,
      isRevealable = _ref2$isRevealable === void 0 ? true : _ref2$isRevealable,
      label = _ref2.label,
      helperText = _ref2.helperText,
      inputProps = _ref2.inputProps,
      _ref2$revealedInputTy = _ref2.revealedInputType,
      revealedInputType = _ref2$revealedInputTy === void 0 ? 'text' : _ref2$revealedInputTy,
      className = _ref2.className;
  var Toggle = customToggle ? customToggle : ShowButton;

  var _useState = useState('password'),
      _useState2 = _slicedToArray(_useState, 2),
      inputType = _useState2[0],
      setInputType = _useState2[1];

  var isHidingText = inputType === 'password';

  var handleShow = function handleShow() {
    if (inputType === 'password') {
      setInputType(revealedInputType);
    } else {
      setInputType('password');
    }
  };

  return /*#__PURE__*/React.createElement(StyledTextInput, {
    className: className,
    adornments: {
      right: isRevealable && !inputProps.disabled && /*#__PURE__*/React.createElement(Toggle, {
        onClick: handleShow
      }, isHidingText ? /*#__PURE__*/React.createElement(AcornsIcon, {
        icon: AcornsIcon.Icon.UtilityShow,
        height: '24px'
      }) : /*#__PURE__*/React.createElement(AcornsIcon, {
        icon: AcornsIcon.Icon.UtilityHide,
        height: '24px'
      }))
    },
    error: error,
    errorText: errorText,
    decorators: {
      bottom: helperText && /*#__PURE__*/React.createElement(HelperText, null, helperText)
    },
    inputProps: _objectSpread(_objectSpread({}, inputProps), {}, {
      'data-testid': TEXT_INPUT,
      type: inputType
    }),
    label: label
  });
};

export { PrivateInputV3 };